import React from "react";
import {
  Box,
  Typography,
} from "@mui/material";
import logo from "../../Assets/Images/logo-faqeer.png";

const HomeSection = () => {

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
       
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            border: "0.5px solid silver",
            width: { lg: "25%", md: "40%", sm: "70%", xs: "90%" },
            padding: "30px 30px 50px 30px",
            borderRadius: "13px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={logo} alt="" width={130} />
          </div>
          <Typography className="heading" sx={{ textAlign: 'center' }}>Welcome to kahay faqeer</Typography>
        </Box>
      </div>
       </>
  );
};

export default HomeSection;
